// @flow
export const ROOT_ROUTE = '/';
export const INTRO_ROUTE = '/:categoryId';
